import { render, staticRenderFns } from "./PreviewDokumen.vue?vue&type=template&id=5c95fa08"
import script from "./PreviewDokumen.vue?vue&type=script&lang=js"
export * from "./PreviewDokumen.vue?vue&type=script&lang=js"
import style0 from "./PreviewDokumen.vue?vue&type=style&index=0&id=5c95fa08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports